export enum DashboardRoleId {
    DataScientist = 0,
    BusinessTech = 1,
    Owner = 2,
    AdminDashboard = 3
}